// Unified travel model — change here to affect GameManager and Block together
export const SPAWN_Z = -16;
export const TARGET_STRIKE_Z = -0.62; // visual contact point in front of the player/blade
export const TRAVEL_TIME = 2.5; // seconds from spawn to strike point
export const TRAVEL_SPEED = Math.abs(TARGET_STRIKE_Z - SPAWN_Z) / TRAVEL_TIME;

export const MISS_Z = 0.6; // auto-miss when block passes this Z
export const BLOCK_SIZE = 0.32; // base target size in metres
export const HIT_RADIUS = 0.22; // generous recognition; difficulty comes from choreography
export const MIN_SLASH_SPEED = 1.55; // m/s at blade tip to count as a cut
export const DIRECTION_DOT_THRESHOLD = 0.2; // ~78deg cone; wrong-way cuts still fail

// Ring-buffer length for the tenouchi "snap" metric (Katana.tsx/grading.ts):
// speed spike vs. the moving average of the preceding samples, instead of raw
// instantaneous speed — rewards the squeeze/acceleration at impact rather
// than sustained fast flailing. 8 samples is a rough ~100ms window at a
// typical Quest frame rate; approximate on purpose, like every other
// constant here — tune on-device.
export const SNAP_WINDOW_SAMPLES = 8;

// Kata (seq) completion bonus, as a multiple of the points actually earned on
// that sequence's notes. Scaling with earned points (rather than a flat sum)
// keeps the bonus proportionally meaningful at every combo/grade tier — see
// .extras/story/Addendum canvas integration v1.md, "CRITICAL COUPLING".
export const KATA_BONUS_RATIO = 1.0;

// Raises the player's XROrigin when "seated" is selected, so a seated head
// height (~1.1-1.2m above the tracked floor) lands back near the standing
// eye height (~1.6m) the target lane is authored around. Starting value only
// — per the addendum's generous-then-tighten methodology, this needs
// on-device confirmation on a real Quest, which this project hasn't had
// access to yet.
export const SEATED_HEIGHT_OFFSET = 0.45; // metres
